document.addEventListener("alpine:init", () => {
    Alpine.data("team", () => ({
        treshold: 1024,
        isMobile: false,
        showAll: false,
        checkMobile() {
            this.isMobile = window.innerWidth < this.treshold;
        },
        init() {
            this.checkMobile();
            this.bindOnResize();
        },
        bindOnResize() {
            window.addEventListener('resize', () => this.checkMobile());
        },
    }));
});
//
// const stickyHeadline = document.getElementById("stickyHeadline");
// const headlines = document.getElementsByClassName("list-headline");
// const searchHeader = document.getElementById("searchHeader");
//
// window.addEventListener("scroll", () => {
//     if (!searchHeader) return;
//
//     if (window.scrollY - 40 < searchHeader.offsetHeight) {
//         stickyHeadline.textContent = "";
//     }
//     for (const headline of headlines) {
//         if (window.scrollY + searchHeader.offsetHeight - 40 > headline.offsetTop) {
//             if (stickyHeadline.textContent != headline.textContent) {
//                 stickyHeadline.textContent = headline.textContent;
//             }
//         }
//     }
// });
